import { NgModule } from '@angular/core';
import { IrisFieldTranslateComponent } from './field-translate.component';

@NgModule({
  imports: [
    IrisFieldTranslateComponent, // Standalone
  ],
  exports: [
    IrisFieldTranslateComponent,
  ],
})
export class IrisFieldTranslateModule { }
